// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"314":"b5c2df1e","488":"ef50d017","526":"d4632761"}[chunkId] + ".chunk.js";
};